import classNames from 'classnames';

import { LinkButton } from 'shared/components/button/Button';
import Edit from 'shared/components/icon/Edit';
import Locked from 'shared/components/icon/Locked';
import { getText } from 'shared/utils/Text';

import styles from './index.module.scss';

function ownerFirstSorter(a, b) {
  if (a.owner) {
    return -1;
  }
  if (b.owner) {
    return 1;
  }
  return 0;
}

const CollaboratorList = ({ collaborators, claimStatus, invitePath }) => (
  <div>
    <div>
      {[...collaborators]
        .sort(ownerFirstSorter)
        .map(({ id, email, alias, accepted, self, owner }) => (
          <div
            className={classNames(styles.collaborator, {
              [styles.notAccepted]: !accepted && !owner,
            })}
            title={
              !accepted && !owner
                ? getText('collaborator-list-not-accepted-tooltip', email)
                : undefined
            }
            key={id}
          >
            {self && !owner ? (
              <LinkButton
                className={styles.emailLink}
                title={getText('collaborator-list-manage-user-tooltip')}
                to={invitePath}
              >
                <span className={styles.email}>{alias}</span>{' '}
                <Edit className={styles.editIcon} />
              </LinkButton>
            ) : (
              <span className={styles.email}>{alias || email}</span>
            )}
            {claimStatus.currentOwner === id && (
              <span title={getText('collaborator-list-current-claim-tooltip')}>
                <Locked className={styles.claimedIcon} />
              </span>
            )}
          </div>
        ))}
    </div>
  </div>
);

export default CollaboratorList;
